import React from "react";
import { Collapse, Checkbox, Row, Col } from "antd";

const { Panel } = Collapse;

function SelectorCamposReporte({ grupos, nivelDetalle, value, onChange }) {
  const toggleCampo = (key, checked) => {
    if (checked) onChange([...value, key]);
    else onChange(value.filter((v) => v !== key));
  };

  const toggleGrupo = (camposGrupo, marcarTodos) => {
    const keysGrupo = camposGrupo.map((c) => c.key);
    if (marcarTodos) {
      onChange([...new Set([...value, ...keysGrupo])]);
    } else {
      onChange(value.filter((v) => !keysGrupo.includes(v)));
    }
  };

  if (grupos.length === 0) return null;

  return (
    <Collapse defaultActiveKey={grupos.map((g) => g.grupo)} style={{ marginBottom: 16 }}>
      {grupos.map((g) => {
        const camposVisibles = g.campos.filter(
          (c) => !c.soloFiltro && !(nivelDetalle === "cabecera" && c.soloDetalle)
        );
        if (camposVisibles.length === 0) return null;
        const todosMarcados = camposVisibles.every((c) => value.includes(c.key));

        return (
          <Panel
            key={g.grupo}
            header={
              <span style={{ fontSize: 12, fontWeight: 700, letterSpacing: "0.04em", textTransform: "uppercase", color: "#595959" }}>
                {g.grupo}
              </span>
            }
            extra={
              <Checkbox
                checked={todosMarcados}
                onClick={(e) => e.stopPropagation()}
                onChange={(e) => toggleGrupo(camposVisibles, e.target.checked)}
              >
                <span style={{ fontSize: 12 }}>Todos</span>
              </Checkbox>
            }
          >
            <Row gutter={[16, 10]}>
              {camposVisibles.map((c) => (
                <Col xs={24} sm={12} md={8} lg={6} key={c.key}>
                  <Checkbox checked={value.includes(c.key)} onChange={(e) => toggleCampo(c.key, e.target.checked)}>
                    {c.label}
                  </Checkbox>
                </Col>
              ))}
            </Row>
          </Panel>
        );
      })}
    </Collapse>
  );
}

export default SelectorCamposReporte;
